angular.module('rightPaneModule')
    .controller('CreateAssignmentController', [
        '$scope',
        'assignedFocusApi',
        'dblAssignmentService',
        'standard',
        'translateFilter',
        function (
            $scope,
            dblAssignedFocusApiService,
            dblAssignmentService,
            dblStandardService,
            translateFilter) {

    var self = this;

    var durationSearchName =  translateFilter('assignments.searchForDuration');
    var defaultDurationSpot = { name: translateFilter('assignments.nWeeks', {count: 1}), id: 1 };
    var defaultDurationGoal = { name: translateFilter('assignments.nWeeks', {count: 2}), id: 2 };
    $scope.durationSearchName = durationSearchName;

    var durationGoal = {
          status: {
              opened: false
          },
          weeks: [
              { name: translateFilter('assignments.nWeeks', {count: 2}), id: 2 },
              { name: translateFilter('assignments.nWeeks', {count: 3}), id: 3 },
              { name: translateFilter('assignments.nWeeks', {count: 4}), id: 4 },
              { name: translateFilter('assignments.nWeeks', {count: 5}), id: 5 },
              { name: translateFilter('assignments.nWeeks', {count: 6}), id: 6 },
              { name: translateFilter('assignments.nWeeks', {count: 7}), id: 7 },
              { name: translateFilter('assignments.nWeeks', {count: 8}), id: 8 },
              { name: translateFilter('assignments.nWeeks', {count: 9}), id: 9 },
              { name: translateFilter('assignments.nWeeks', {count: 10}), id: 10 }
          ],
          selected : defaultDurationGoal
    };

    var durationSpot = {
          status: {
              opened: false
          },
          weeks: [
              { name: translateFilter('assignments.nWeeks', {count: 1}), id: 1 },
              { name: translateFilter('assignments.nWeeks', {count: 2}), id: 2 },
          ],
          selected : defaultDurationSpot
    };

    this.getFocusType = function(item) {
        if (!item) {
            return '';
        }

        if(item.domain) {
            return 'domain';
        } else if (item.cluster) {
            return 'cluster';
        } else {
            return 'standard';
        }
    };

    $scope.$watch('assignmentType', function (value) {
        if (value) {
            setAssignmentType(value);
        }
    });

    $scope.durationClicked = function(duration) {
        setSelectedDuration(duration);
    };

    function setAssignmentType (assignmentType) {
        if($scope.assignmentType === 'GOAL') {
            $scope.allowDomainAssignment = true;
            $scope.duration = durationGoal;
            setSelectedDuration(defaultDurationGoal);
        } else {
            $scope.allowDomainAssignment = false;
            $scope.duration = durationSpot;
            setSelectedDuration(defaultDurationSpot);
        }
    }

    function setSelectedDuration (duration) {
        $scope.duration.selected = duration;

        // duration.id is number of weeks in assignment
        setAssignmentDates(duration.id);
    }

    function setAssignmentDates (durationInWeeks) {
        var assignmentDates = dblAssignmentService.generateAssignmentDates(durationInWeeks);

        $scope.startDate = assignmentDates.start.toDate();
        $scope.endDate = assignmentDates.end.toDate();
    }

    this.setIsPrimaryStandardSelected = function () {

    };

    this.getPrimaryStandards = function (focus_type) {

    };

    this.processProficiencySlots = function () {
        var focusType = self.getFocusType($scope.currentStandard);

        if (focusType === 'standard' && _.isUndefined(dblStandardService.getParams().standard)) {
          return;
        }

        var focusId = focusType === 'domain' ? dblStandardService.getParams().domain : dblStandardService.getParams().standard;

        return dblAssignedFocusApiService.getProficiencySlots(focusType, focusId).then(function (resource) {
          $scope.notStartedLessonSlotId = resource.data.not_started_lesson_slot_id;
          $scope.inProgressLessonSlotId = resource.data.in_progress_lesson_slot_id;
          $scope.proficientLessonSlotId = resource.data.proficient_lesson_slot_id;
        });
    };

    this.setAssignmentTypeSpot = function () {
        $scope.assignmentType = "SPOT";
        $scope.duration = durationSpot;
    };

    this.setAssignmentDates = setAssignmentDates;
}]);
